var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateWebHosting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 17.902H4.667c-.53 0-1.04-.109-1.415-.302-.375-.194-.585-.457-.585-.731V7.91c0-.275.21-.537.585-.731.375-.194.884-.303 1.415-.303h22.666c.53 0 1.04.109 1.414.303.375.194.586.456.586.73v4.804",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 26.667h-12a2 2 0 0 1-2-2V7.334a2 2 0 0 1 2-2h22.667a2 2 0 0 1 2 2v9.294",
    stroke: "url(#d39vqw68pa)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 7.334a2 2 0 0 1 2-2h22.666a2 2 0 0 1 2 2v6H2.667v-6z",
    stroke: "url(#wirz7ku5eb)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 23.334h8m-4-4v8",
    stroke: "url(#fzf89ryopc)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 9.335a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z",
    fill: "url(#0nf0qs50gd)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 9.335a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z",
    fill: "url(#vhk83chhke)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d39vqw68pa",
    x1: 22.454,
    y1: 38.096,
    x2: -2.836,
    y2: 25.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wirz7ku5eb",
    x1: 22.454,
    y1: 17.62,
    x2: 10.861,
    y2: 2.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fzf89ryopc",
    x1: 27.269,
    y1: 31.62,
    x2: 19.115,
    y2: 28.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0nf0qs50gd",
    x1: 3.905,
    y1: 8.689,
    x2: 4.969,
    y2: 11.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vhk83chhke",
    x1: 7.905,
    y1: 8.689,
    x2: 8.969,
    y2: 11.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateWebHosting);
export default __webpack_public_path__ + "static/media/corporateWebHosting.e10646c6e38be1dc5a90404e550dd734.svg";
export { ForwardRef as ReactComponent };